import React, { useState } from 'react';

function PopupUserProfile({ formData, onChange, onSubmit, onClose, onLogout }) {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const openLogoutConfirm = () => {
    setShowLogoutConfirm(true);
  };

  const closeLogoutConfirm = () => {
    setShowLogoutConfirm(false);
  };

  const handleLogoutConfirm = () => {
    setShowLogoutConfirm(false);
    onLogout();
  };

  return (
    <div className="popup-user-profile" onClick={(event) => event.stopPropagation()}>
      <button
        className="popup-user-profile__close-button"
        type="button"
        onClick={onClose}
        aria-label="Закрыть профиль"
      ></button>
      <h2 className="popup-user-profile__heading">Ваши персональные данные</h2>
      <form className="popup-user-profile__form" onSubmit={onSubmit}>
        <div className="popup-user-profile__form-profile">
          <label>
            Фамилия Имя Отчество
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={onChange}
              placeholder="ФИО"
              required
            />
          </label>
          <label>
            Дата рождения:
            <input
              type="date"
              name="birthday"
              value={formData.birthday}
              onChange={onChange}
              disabled
              required
            />
          </label>
        </div>
        <div className="popup-user-profile__form-profile">
          <label>
            Номер телефона:
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={onChange}
              disabled
              placeholder="Телефон"
              required
            />
          </label>
          <label>
            Электронная почта:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={onChange}
              placeholder="Email"
              required
            />
          </label>
        </div>
        <button className="popup-user-profile__button popup-user-profile__button_green" type="submit">
          Сохранить
        </button>
        <button className="popup-user-profile__button" type="button" onClick={onClose}>
          Отмена
        </button>
      </form>
      <h3 className="popup-user-profile__heading">Накоплено бонусов</h3>
      <div className="popup-user-profile__bonus">{formData?.walletBalances?.[0]?.balance || 0} рублей</div>
      <button className="popup-user-profile__button" onClick={openLogoutConfirm} type="button">
        Выйти из аккаунта
      </button>
      {showLogoutConfirm && (
        <div className="popup-user-profile__confirm-overlay" onClick={closeLogoutConfirm}>
          <div className="popup-user-profile__confirm" onClick={(event) => event.stopPropagation()}>
            <p className="popup-user-profile__confirm-text">
              Выйти из аккаунта? Для заказа потом нужно будет войти снова.
            </p>
            <div className="popup-user-profile__confirm-actions">
              <button className="popup-user-profile__button popup-user-profile__button_green" type="button" onClick={handleLogoutConfirm}>
                Выйти
              </button>
              <button className="popup-user-profile__button" type="button" onClick={closeLogoutConfirm}>
                Отмена
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PopupUserProfile;
